/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-20 15:21:32
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-10-15 15:09:53
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelProductsConfig/SalesChannelProductAlias/EditPage/MiniInfo/index.tsx
 */

import React from 'react';
import { getI18nFromGeneral } from '@/src/tools/tools';

//import css from './css.less';
import Info from 'src/constrains/SalesChannelPreviewPageComponents/MiniProgramPageInfo';
import {
  EnumCollapseId,
  getCollapseOpenStatus,
  getCollapseValidationMsgDisplay,
  getGeneralMiniProgramPageInfo,
  onCollapseOpen,
  onErrorChange,
} from '../slice';

import ErrorProcessingHOC from 'src/constrains/SalesChannelPreviewPageComponents/ErrorProcessingHOC';

const MiniProgramShare = (props) => {
  const { data } = props;

  // const _d = useDispatch();

  const { miniProgramPath, miniProgramAppId, miniProgramQRCode } = data || {};

  return (
    <React.Fragment>
      <Info
        miniProgramPath={miniProgramPath}
        miniProgramAppId={miniProgramAppId}
        miniProgramQRCode={miniProgramQRCode}
      />
    </React.Fragment>
  );
};
export default ErrorProcessingHOC(MiniProgramShare, {
  getCollapseOpenStatus,
  onCollapseOpen,
  id: EnumCollapseId.miniProgramPageInfo,
  getContent: getGeneralMiniProgramPageInfo,
  title: getI18nFromGeneral('general.hOCTitle.miniProgramPageInformation'),
  getErrorDisplay: getCollapseValidationMsgDisplay,
  onErrorChange,
});
